import { configureStore } from "@reduxjs/toolkit";
import viewMenuReducer from './ViewMenuSlice';
import userReducer from './UserSlice';
import awardsReducer from './AwardsSlice';
import entriesReducer from './EntriesSlice';
import myListReducer from './MylistSlice';
import { save } from "../Utils/Storage";
import { VIEW_MENU_STORAGE_KEY } from "../config/config";



const store = configureStore({
    reducer : {
        viewMenu: viewMenuReducer,
        user: userReducer,
        awards: awardsReducer,
        entries: entriesReducer,
        myList: myListReducer
    }
});
store.subscribe(() => {
    save(VIEW_MENU_STORAGE_KEY, store.getState().viewMenu.viewType);
})

export default store;
export type RootState = ReturnType<typeof store.getState>
